module.exports = (__webpack_require__(7))(17);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@angular/common/esm5/common.js from dll-reference vendor
// module id = 12
// module chunks = 0